import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"

import SubmissionDetailAnswer from "../../views/retriever/SubmissionDetailAnswer.jsx"

import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Switch,
  FormControlLabel,
  List,
} from '@material-ui/core';

class SubmissionDetailStage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      stageData: this.props.stageData,
      answerDataList: props.answerDataList,
      showAllAnswers: false,
    };
    autoBind(this);
  }

  onShowAllToggle(e) {
    this.setState({
      showAllAnswers: e.target.checked,
    });
    this.state.showAllAnswers = e.target.checked;
  }

  render() {
    var displayDataList = [];
    var showViewMore = false;
    if (this.state.showAllAnswers) {
      displayDataList = this.state.answerDataList;
      showViewMore = true;
    }
    else {
      for (let i = 0; i < this.state.answerDataList.length; i++) {
        var srcRow = this.state.answerDataList[i];
        var found = false;
        for (let j = 0; j < displayDataList.length; j++) {
          if (srcRow.playback_id == displayDataList[j].playback_id) {
            found = true;
          }
        }
        if (!found) {
          displayDataList.push(srcRow);
        }
        showViewMore = (displayDataList.length != this.state.answerDataList.length);
      }
    }

    return (
      <div>
        <Card style={{margin:"0 16px 16px 0"}}>
          <CardHeader
            title={this.state.stageData['stage_name']}
            subheader={
              <If condition={showViewMore}>
                <Then>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.showAllAnswers}
                        onChange={this.onShowAllToggle}
                      />
                    }
                    label={Localization.strings.SHOW_ALL_ATTEMPTS}
                  />
                </Then>
              </If>
            }
          />
          <CardContent>
            <If condition={this.state.answerDataList.length == 0}>
              <Then>
                <Divider/>
                <br/>
                {Localization.strings.NO_ANSWER}
              </Then>
              <Else>
                {displayDataList.map( (row, i) => {
                  return [
                    <Divider/>,
                    <List>
                      <SubmissionDetailAnswer parent={this} root={this.props.root}
                        answerData={row}
                        showCompareButton={true}
                        showUserName={false}
                        key={row['id']}
                      />
                    </List>,
                  ];
                })}
              </Else>
            </If>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default SubmissionDetailStage;
